export const IBaseCoordinatorType = Symbol('IBaseCoordinator');
